/**
 * Close details element when pressing the escape key or clicking outside of it.
 * Default behavior of the details element is to close when clicking again on the summary element.
 * @param {string} detailsId - The id of the details element to close.
 */

function closeDetailsWithEsc(detailsId) {
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      document.getElementById(detailsId).removeAttribute('open');
    }
  });
}

function closeDetailsOnClickOutside(detailsId) {
  document.addEventListener('click', (event) => {
    if (!document.getElementById(detailsId).contains(event.target)) {
      document.getElementById(detailsId).removeAttribute('open');
    }
  });
}

closeDetailsWithEsc('language-selector');
closeDetailsOnClickOutside('language-selector');
